import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/ImageList": ImageList, "@mui/material/ImageListItem": ImageListItem } } });
export default ClientProvider;
